import React, { useContext, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';
import { Store } from '../Store';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CheckoutSteps from '../components/CheckoutSteps';
import CardHeader from '../components/CardHeadder';
import { Container } from 'react-bootstrap';
import countries from '../countries';

export default function ShippingAddressScreen() {
  const navigate = useNavigate();

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const {
    cart: { shippingAddress },
  } = state;

  const [fullName, setFullName] = useState(shippingAddress.fullName || '');
  const [address, setAddress] = useState(shippingAddress.address || '');
  const [city, setCity] = useState(shippingAddress.city || '');
  const [postalCode, setPostalCode] = useState(
    shippingAddress.postalCode || ''
  );
  const [country, setCountry] = useState(shippingAddress.country || 'Sri Lanka');
  const selectedCountry = countries.find(c => c.name === country) || countries[0];
  const countryCode = selectedCountry.code;

  // Initialize whatsapp state by stripping current country code if it exists
  const initialWhatsapp = shippingAddress.whatsapp 
    ? shippingAddress.whatsapp.startsWith(countryCode) 
        ? shippingAddress.whatsapp.substring(countryCode.length)
        : shippingAddress.whatsapp
    : '';
  
  const [whatsapp, setWhatsapp] = useState(initialWhatsapp);
  const [email, setEmail] = useState(shippingAddress.email || '');

  const submitHandler = (e) => {
    e.preventDefault();
    
    // Combine country code with local part
    let localPart = whatsapp.replace(/[^0-9]/g, '');
    if (localPart.startsWith('0')) {
        localPart = localPart.substring(1);
    }
    const formattedWhatsapp = countryCode + localPart;

    ctxDispatch({
      type: 'SAVE_SHIPPING_ADDRESS',
      payload: {
        fullName,
        address,
        city,
        postalCode,
        country,
        whatsapp: formattedWhatsapp,
        email,
      },
    });
    localStorage.setItem(
      'shippingAddress',
      JSON.stringify({
        fullName,
        address,
        city,
        postalCode,
        country,
        whatsapp: formattedWhatsapp,
        email,
      })
    );
    navigate('/placeorder');
  };

  const smallContainerStyle = {
    maxWidth: '600px',
  };

  return (
    <div>
      <CardHeader />
      <Container fluid="md" className="mt-5 py-5">
        <div className="marginAll">
          <Helmet>
            <title>Shipping Address</title>
          </Helmet>
          <CheckoutSteps step1 step2></CheckoutSteps>
          <div style={smallContainerStyle} className="container ">
            <br />
            <h1 style={{ fontSize: '2rem', color: '#801001', fontWeight: 'bold' }}>
              Shipping Address
            </h1>
            <br />
            <Form onSubmit={submitHandler}>
              <Form.Group className="mb-3" controlId="fullName">
                <Form.Label>Full Name</Form.Label>
                <Form.Control
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  required
                />
              </Form.Group>

              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="address">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="city">
                    <Form.Label>City</Form.Label>
                    <Form.Control
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3" controlId="postalCode">
                    <Form.Label>Postal Code</Form.Label>
                    <Form.Control
                      value={postalCode}
                      onChange={(e) => setPostalCode(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3" controlId="country">
                <Form.Label>Country</Form.Label>
                <Form.Select
                  value={country}
                  onChange={(e) => setCountry(e.target.value)}
                  required
                >
                  {countries.map((c) => (
                    <option key={c.name} value={c.name}>
                      {c.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="whatsapp" as={Col}>
                    <Form.Label>WhatsApp Number</Form.Label>
                    <InputGroup>
                      <InputGroup.Text id="basic-addon1">+{countryCode}</InputGroup.Text>
                      <Form.Control
                        type="tel"
                        value={whatsapp}
                        placeholder="Enter local number"
                        onChange={(e) => setWhatsapp(e.target.value)}
                        required
                      />
                    </InputGroup>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3" controlId="email" as={Col}>
                    <Form.Label>Email Address</Form.Label>
                    <Form.Control
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>
              <div className="mb-3">
                <Button variant="primary" type="submit">
                  Continue
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </Container>
    </div>
  );
}
